module.exports = __webpack_public_path__ + "img/miaoyinniangzi.97582d49.png";